import { render } from "./TheCars.vue?vue&type=template&id=4f0a488b"
import script from "./TheCars.vue?vue&type=script&lang=js"
export * from "./TheCars.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__